import { Link } from "react-router-dom";
import { Compass, ShieldOff } from "lucide-react";
import { EmptyState, Panel } from "@vixio/ui";

export function NotFound() {
  return (
    <div className="vx-content">
      <Panel>
        <EmptyState
          heading
          icon={Compass}
          title="Página não encontrada"
          actions={
            <Link className="vx-btn vx-btn--primary" to="/">
              Voltar ao início
            </Link>
          }
        >
          O endereço não existe ou o módulo desta tela não está ligado nesta organização. Use o menu ou a busca{" "}
          <kbd className="vx-kbd">Ctrl K</kbd> para achar a tela.
        </EmptyState>
      </Panel>
    </div>
  );
}

export function Forbidden() {
  return (
    <div className="vx-content">
      <Panel>
        <EmptyState
          heading
          icon={ShieldOff}
          title="Sem acesso a esta tela"
          actions={
            <Link className="vx-btn" to="/">
              Voltar ao início
            </Link>
          }
        >
          O seu papel nesta organização não inclui esta área. Se precisar, peça a quem administra a organização.
        </EmptyState>
      </Panel>
    </div>
  );
}
